import { useCallback, useLayoutEffect, useRef } from "react";
import { isDefaultOptionEqualToValue } from "../utils/defaultIsOptionEqualToValue.js";
function useActions(value, selectableOptions, selectedOptions, isOptionEqualToValue, onChange) {
  const rValues = useRef({ value, selectableOptions, selectedOptions, isOptionEqualToValue });
  useLayoutEffect(() => void (rValues.current = { value, selectableOptions, selectedOptions, isOptionEqualToValue }));
  const handleOnChange = useCallback(
    (_, value2) => {
      onChange?.(value2);
    },
    [onChange]
  );
  const selectUnselected = useCallback(() => {
    const { value: value2, selectableOptions: selectableOptions2 } = rValues.current;
    const nextValue = [...value2, ...selectableOptions2];
    onChange?.(nextValue);
  }, [onChange]);
  const clearSelected = useCallback(() => {
    const { value: value2, selectedOptions: selectedOptions2, isOptionEqualToValue: isOptionEqualToValue2 } = rValues.current;
    let nextValue = [];
    if (isDefaultOptionEqualToValue(isOptionEqualToValue2)) {
      const valueAsSet = new Set(value2);
      nextValue = value2.filter((option) => !valueAsSet.has(option));
    } else {
      nextValue = value2.filter((option) => !selectedOptions2.some((item) => isOptionEqualToValue2(item, option)));
    }
    onChange?.(nextValue);
  }, [onChange]);
  return {
    onChange: handleOnChange,
    clearSelected,
    selectUnselected
  };
}
export {
  useActions
};
//# sourceMappingURL=useActions.js.map
